module.exports = __webpack_public_path__ + "img/tema-1-10.f53e0635.png";